import { usePromiseTracker } from "react-promise-tracker";
import Loader from 'react-loader-spinner';
import './LoadingIndicator.css';

export default function LoadingIndicator () {
  const { promiseInProgress } = usePromiseTracker();
  return (
    promiseInProgress && 
    <div className="loader-container">
      <Loader type="ThreeDots" className="loader" />
    </div>
  );  
}